import reasonLogoPNG from '../../images/store/reason-logo.png';
import { Link } from '../Link';

const NAV_ITEMS = [
  { key: 'home', label: 'HOME', to: '/', type: 'link' },
  { key: 'news', label: 'NEWS', href: '#', type: 'anchor' },
  { key: 'vote', label: 'VOTE', to: '/vote', type: 'link' },
  { key: 'hiscores', label: 'HISCORES', to: '/hiscores', type: 'link' },
  { key: 'store', label: 'STORE', to: '/store', type: 'link' },
  { key: 'play', label: 'PLAY', to: '/play', type: 'link' },
];

function NavItem({ item, activePage, onNavigate }) {
  const selected = item.key === activePage ? ' selected' : '';
  const content = <div className={`nav-item${selected}`}>{item.label}</div>;

  if (item.type === 'link') {
    return (
      <Link to={item.to} onClick={onNavigate}>
        {content}
      </Link>
    );
  }

  return (
    <a href={item.href} onClick={onNavigate}>
      {content}
    </a>
  );
}

export default function ReasonNav({ activePage, menuOpen, setMenuOpen }) {
  function closeMenu() {
    setMenuOpen(false);
  }

  function toggleMenu() {
    setMenuOpen((open) => !open);
  }

  const leftItems = NAV_ITEMS.slice(0, 3);
  const rightItems = NAV_ITEMS.slice(3);

  return (
    <header className="nav-bar">
      <div className="navbar-main">
        <div className="container mx-auto">
          <button
            type="button"
            className="mobile-menu-button"
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            &#9776;
          </button>

          <div
            className={`menu-overlay${menuOpen ? ' show' : ''}`}
            onClick={closeMenu}
            aria-hidden="true"
          />

          <div className={`mobile-menu${menuOpen ? ' show' : ''}`}>
            {NAV_ITEMS.map((item) => (
              <NavItem key={item.key} item={item} activePage={activePage} onNavigate={closeMenu} />
            ))}
          </div>

          <nav className="nav-links">
            {leftItems.map((item) => (
              <NavItem key={item.key} item={item} activePage={activePage} />
            ))}
            <span className="nav-logo-spacer" aria-hidden="true" />
            {rightItems.map((item) => (
              <NavItem key={item.key} item={item} activePage={activePage} />
            ))}
          </nav>

          <div className="logo">
            <img src={reasonLogoPNG} alt="Logo" />
          </div>
        </div>
      </div>
    </header>
  );
}
